import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { vendorsApi } from "@/lib/api";
import type { SupportedVendor } from "@/types";

interface UseSupportedVendorsReturn {
  vendors: SupportedVendor[];
  getVendorNameById: (id: string | null | undefined) => string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export const useSupportedVendors = (): UseSupportedVendorsReturn => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["supported-vendors"],
    queryFn: vendorsApi.getSupportedVendors,
    staleTime: Infinity,
  });

  const vendors = data ?? [];

  const getVendorNameById = useMemo(() => {
    const nameById = new Map(vendors.map((v) => [v.id, v.name]));
    return (id: string | null | undefined) => (id ? nameById.get(id) : undefined);
  }, [vendors]);

  return {
    vendors,
    getVendorNameById,
    isLoading,
    isError,
    error,
  };
};
